module.exports = __webpack_public_path__ + "img/buds-fest.e607472f.png";